// AGENT-DASH-TOOLTIP: a text span that exposes a hover tooltip ONLY when its
// content is actually clipped (scrollWidth > clientWidth). Short labels that
// fit get no tooltip, so the user isn't pestered by redundant pop-ups — only
// the longer, truncated category / product names reveal their full text on
// hover. Re-checks on resize so it stays correct as the sidebar is widened.

import { useLayoutEffect, useRef, useState } from "react";

export interface TruncatedLabelProps {
  text: string;
  className?: string;
}

export function TruncatedLabel({ text, className }: TruncatedLabelProps): JSX.Element {
  const ref = useRef<HTMLSpanElement>(null);
  const [truncated, setTruncated] = useState(false);

  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    const check = (): void => setTruncated(el.scrollWidth > el.clientWidth + 1);
    check();
    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [text]);

  return (
    <span ref={ref} className={className} title={truncated ? text : undefined}>
      {text}
    </span>
  );
}

export default TruncatedLabel;
